import React, { Component } from 'react';
import API from '../services/api';
import './Steps.css';
import config from '../config';
import AuthService from '../services/auth';
import { Link } from 'react-router-dom';
import { auth, db } from '../firebase';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      errors: [],
    }
  }

  handleFieldChange(e, name) {

    let newState = this.state;
    newState[name] = e.target.value;
    newState.errors = [];
    this.setState(newState, );
  }

  handleSubmit(e) {
    e.preventDefault();
    const { username, password } = this.state;
    if(username.length > 0 && password.length > 0) {
      (new API()).auth(`/oauth/token`, { ...config.oauthConfig, username, password })
        .then(response => {
          if(response.error) {
            this.setState({
              errors: [
                response.message
              ]
            })
          } else {
            AuthService.setAuthCookie(response.access_token);
            auth.doSignInWithEmailAndPassword(username, password)
              .then(() => {
                window.location = '/';
              })
              .catch(error => {
                if(error.code === 'auth/user-not-found') {
                  auth.doCreateUserWithEmailAndPassword(username, password)
                    .then(authUser => {
                      AuthService.setAuthCookie(response.access_token);
                      (new API()).get('/users/current',{}, AuthService.getAuthCookie())
                        .then(response => {
                          db.doCreateUser(response.user.id, response.user.name, response.user.email);
                          auth.doSignInWithEmailAndPassword(username, password)
                            .then(() => {
                              window.location = '/';
                            });
                        });
                    })

                } else if(error.code === 'auth/wrong-password') {
                  this.setState({
                    errors: [
                      'There was a problem with your account data, please contact us on support@upperclassdates.com, and let us handle the issue.',
                    ],
                  });
                }
              });
          }
        }).catch((error) => {
            this.setState({
              errors: [
                error.message
              ]
            })
      });
    }else{
      this.setState({
        errors: [
          'Both fields must be filled.'
        ]
      })
    }
  }

  render() {
    const { errors } = this.state
    return (
      <div className="container">
        <div className="intro">
          <h1>UPPERCLASSDATES</h1>
          <div className="subtitle">
            Log in to UpperClassDates.
          </div>
        </div>
        <form className="login">
          <div className="Step Step-container active">
            <div className="Step-title">
              Log in
            </div>
            <div className="field-container text open">
              <div className="field-title">Email Address:</div>
              <div className="row">
                <div className="col">
                  <input onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="username" placeholder="Your email..." />
                </div>
              </div>
            </div>
            <div className="field-container text open">
              <div className="field-title">Password:</div>
              <div className="row">
                <div className="col">
                  <input onChange={e => this.handleFieldChange(e, e.target.name)} type="password" name="password" placeholder="Your password..." />
                  {errors.length > 0 && <span className="error">{errors[0]}</span>}
                </div>
              </div>
            </div>
            <div className="field-container checkbox open">
              <div className="row">
                <div className="col">
                  <input onChange={e => this.handleFieldChange(e, e.target.name)} type="checkbox" name="remember" id="remember" />
                  <label htmlFor="remember" className="field-title">Remember me</label>
                </div>
              </div>
            </div>
            <div className="row button-container left space-between">
              <div className="col">
                <button
                  className="btn btn-primary"
                  onClick={(e) => this.handleSubmit(e)}
                >
                  Log in
                </button>
                <Link to="/forgot-password">Forgot password?</Link>
              </div>
            </div>
          </div>
        </form>
        <div className="texts">
          <div className="row">
            <div className="col center">
              Don't have an account yet? <Link to="/join">Join</Link> now.
            </div>
          </div>
          <div className="row">
            <div className="col">
              <p>
                By continuing you agree to UpperClassDates' <a href="https://upperclassdates.com/privacy-statement/">Privacy Policy</a>.
              </p>
              <p>
                Prostitution and promotion of other commercial activities is prohibited.
              </p>
              <p>
                Are you an escort?, then don't use this website.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js